import { render, staticRenderFns } from "./create-category-modal.vue?vue&type=template&id=606f04a0&"
import script from "./create-category-modal.vue?vue&type=script&lang=js&"
export * from "./create-category-modal.vue?vue&type=script&lang=js&"
import style0 from "./create-category-modal.vue?vue&type=style&index=0&id=606f04a0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports